var _path, _g, _path2, _rect, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5491_229)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5491_229",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 0H0V29H29V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5491_229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 28.5C22.232 28.5 28.5 22.232 28.5 14.5C28.5 6.76801 22.232 0.5 14.5 0.5C6.76801 0.5 0.5 6.76801 0.5 14.5C0.5 22.232 6.76801 28.5 14.5 28.5Z",
    stroke: "#F26D00",
    strokeLinecap: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7887 7V10.0118C15.7887 10.4111 15.9473 10.7942 16.2298 11.0766C16.5122 11.359 16.8952 11.5176 17.2946 11.5176H20.3063M16.5416 7H9.76516C9.36577 7 8.98275 7.15865 8.70034 7.44106C8.41793 7.72347 8.25928 8.1065 8.25928 8.50588V21.4941C8.25928 21.8935 8.41793 22.2765 8.70034 22.5589C8.98275 22.8413 9.36577 23 9.76516 23H18.8005C19.1998 23 19.5829 22.8413 19.8653 22.5589C20.1477 22.2765 20.3063 21.8935 20.3063 21.4941V10.7647L16.5416 7Z",
    stroke: "#F26D00",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 13.0225,
    width: 16.5647,
    height: 7.52941,
    rx: 1,
    fill: "#F26D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7812 19.7998V14.1904H21.433V14.981H18.6697V16.6676H21.1318V17.4582H18.6697V19.7998H17.7812Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2004 19.7998V14.1904H14.0376C14.6199 14.1904 15.1244 14.3084 15.551 14.5443C15.9827 14.7752 16.3165 15.1015 16.5524 15.5231C16.7884 15.9448 16.9063 16.4342 16.9063 16.9914C16.9063 17.5435 16.7884 18.0329 16.5524 18.4596C16.3165 18.8813 15.9827 19.21 15.551 19.446C15.1244 19.6819 14.6199 19.7998 14.0376 19.7998H12.2004ZM13.0889 19.0093H14.0527C14.4492 19.0093 14.7931 18.9264 15.0842 18.7608C15.3804 18.5951 15.6088 18.3617 15.7694 18.0605C15.93 17.7594 16.0103 17.403 16.0103 16.9914C16.0103 16.5798 15.9275 16.2259 15.7619 15.9297C15.6012 15.6285 15.3753 15.3951 15.0842 15.2295C14.7931 15.0638 14.4492 14.981 14.0527 14.981H13.0889V19.0093Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33276 19.7998V14.1904H9.37323C9.7497 14.1904 10.081 14.2607 10.3671 14.4013C10.6583 14.5368 10.8841 14.7376 11.0448 15.0036C11.2054 15.2646 11.2857 15.5784 11.2857 15.9448C11.2857 16.3062 11.2029 16.6174 11.0372 16.8784C10.8766 17.1394 10.6532 17.3402 10.3671 17.4808C10.081 17.6213 9.7497 17.6916 9.37323 17.6916H8.22123V19.7998H7.33276ZM8.22123 16.901H9.39582C9.59661 16.901 9.77229 16.8609 9.92288 16.7805C10.0735 16.7002 10.1914 16.5898 10.2768 16.4493C10.3621 16.3037 10.4048 16.133 10.4048 15.9373C10.4048 15.7415 10.3621 15.5733 10.2768 15.4328C10.1914 15.2872 10.0735 15.1768 9.92288 15.1015C9.77229 15.0212 9.59661 14.981 9.39582 14.981H8.22123V16.901Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5491_229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/PDF.c733e34d4ec5128bbeb03e82ebee9a41.svg";
export { ForwardRef as ReactComponent };